import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { NoExperience } from './components/NoExperience';
import { Gallery } from './components/Gallery';
import { GuideContents } from './components/GuideContents';
import { ProductInside } from './components/ProductInside';
import { Bonuses } from './components/Bonuses';
import { AboutCreator } from './components/AboutCreator';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Deco Emprende | Flores de Chenille Deco';
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '989000920158429');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=989000920158429&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually not necessary for analytics scripts
    };
  }, []);
  return <div className="min-h-screen bg-deco-bg font-sans selection:bg-deco-terra selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <OfferBar data-id="element-2" />
      <main className="overflow-hidden" data-id="element-3">
        <Hero data-id="element-4" />
        <Benefits data-id="element-5" />
        <NoExperience data-id="element-6" />
        <Gallery data-id="element-7" />
        <GuideContents data-id="element-8" />
        <ProductInside data-id="element-9" />
        <Testimonials data-id="element-10" />
        <PurchaseSection data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}